import React, { useState } from 'react';
import { Button } from 'antd';

const LoadingButton = (props) => {
  const [valueLoading, setLoading] = useState<boolean | undefined>(false);
  return (
    <Button
      style={{ borderRadius: 4 }}
      disabled={valueLoading}
      {...props}
      onClick={(...pp) => {
        const res = props.onClick(...pp);
        if (res instanceof Promise) {
          setLoading(true);
          return res.then(
            (rr) => {
              setLoading(false);
              return rr;
            },
            (err) => {
              setLoading(false);
              throw err;
            }
          );
        } else {
          return res;
        }
      }}
    />
  );
};

export default LoadingButton;
